<section class="section-detail">
	<div *ngIf="banner != null" class="container-fluid band p-3" [style.backgroundColor]="banner.color">
		<div class="container px-3">
			<div class="row">
				<div class="col-12 col-md-6 text-center">
					<img *ngIf="banner.image && !banner.youtube" class="img-fluid"
						alt="Afbeelding banner.title"
						[src]="banner.image">

					<iframe style="aspect-ratio: 16 / 9; width: 100%;" *ngIf="banner.youtube" type="text/html"
						[src]="embed(banner.youtube)" frameborder="0"></iframe>
				</div>
				<div class="col-12 col-md-5 my-5 my-sm-0 d-flex">
					<div class="d-flex align-items-center">
						<div class="d-block">
							<div class="text-white">
								<div class="section-title">
									<h2 [innerHTML]="banner.title"></h2>
									<p [innerHTML]="banner.body"></p>
								</div>
							</div>
							<p class="mt-3"><a *ngIf="banner.buttonText" (mouseenter)="hoverButton($event, true)"
									(mouseleave)="hoverButton($event, false)" class="btn"
									[style.color]="banner.buttonTextColor"
									[style.backgroundColor]="banner.buttonBackgroundColor" [href]="banner.link"
									>{{banner.buttonText}}</a></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="banner == null" class="container-fluid band p-3">
		<div class="container px-3">
			<div class="row" *ngIf="!currentUser">
				<div class="col-12 col-md-6 text-center">
					<img [src]="introImage" class="img-fluid" alt="{{systemTitle}} ⋆ {{systemSlogan}}" />
				</div>
				<div class="col-12 col-md-5 my-5 my-sm-0 mt-sm-5 d-flex">
					<div class="d-flex align-items-center">
						<div class="d-block">
							<div class="text-white">
								<h2 class="section-title">{{sectionIntro}}</h2>
							</div>
							<p class="mt-3"><a href="{{salesWebsite}}" title="Lees meer over {{systemTitle}}"
									class="btn  btn-info">Meer informatie voor docenten</a></p>
						</div>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="currentUser" [innerHTML]="introText"></div>
		</div>
	</div>
	<section class="container-fluid main sections">
		<div class="container">
			<h2 class="mt-5">{{electiveData.name}}</h2>
		</div>
	</section>

	<section class="container-fluid main sections grayBG">
		<div class="container py-5">
			<div>
				<div>
					<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-2">
						<div class="col mb-5" id="slugContainer">
							<img src="{{electiveData.image}}" class="card-img-top" alt="Logo {{electiveData.name}}">
							<p id="slug">{{electiveData.slug}}</p>
						</div>
						<div class="col mb-5">
							<div class="card lessonList">
								<ng-container *ngFor="let chapter of chapters">
									<div class="lessonWrapper" [ngClass]="{
										'no-license': !existingElectives.includes(chapter['id']) && checkLicense == true
									}">
										<a href="/les/{{chapter.firstLessonId}}">
											<div>{{numberToLetter(chapter.position)}}</div>
											<div>{{removeFirstThreeChars(chapter.name)}}</div>
										</a>
									</div>
								</ng-container>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</section>

	<section class="container-fluid main sections grayBGOffset" *ngIf="frontType != 'CHAPTER'">

		<div class="container py-5">
			<section class="no-modules-container" *ngIf="topSectionsIsLoaded && topSections.length == 0">
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] == 'STUDENT'">Deze klas heeft
					nog	geen modules toegewezen gekregen. Roep even je docent erbij!</div>
				<div class="alert alert-warning" *ngIf="currentUser && currentUser['role'] != 'STUDENT'">Er zijn op dit
					moment geen actieve licenties voor deze school. Als je al wel een bestelling hebt gedaan, <a
						href="https://uitgeverijneo.nl/contact" target="_blank">neem
						dan contact met ons op</a>.</div>
			</section>

			<div>
				<div>
					<h2 class="mb-4 yellow">Stappenplan</h2>
					<div class="row">
						<div class="col mb-2" *ngFor="let group of choiceAssignments">
							<ng-container *ngFor="let choiceAssignment of group">
								<a href="/les/{{choiceAssignment.id}}">
									<h6 class="card-title">{{choiceAssignment['lesson']['name']}}</h6>
								</a>
							</ng-container>

						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</section>